import { INumberStyle } from "../../../../documaker/domain/format/objects";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface INumberStylePropertyEditable {
  numberStyle(): IPropertyEditable<INumberStyle>;
}

export function instanceOfINumberStylePropertyEditable(instance: any): instance is INumberStylePropertyEditable {
  return instance
      && instance.numberStyle
      && instanceOfIPropertyEditable<INumberStyle>(instance.numberStyle());
}
